// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d424823e","703":"94d72591"}[chunkId] + ".chunk.js";
};